import styled from '@emotion/styled'
import { Locale, Translation } from 'locale'
import React from 'react'
import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'
import { canManageAxeSelector } from 'selectors/permissionSelectors'
import { downloadUrl } from 'utils'
import axeUploadTemplateUrl from '../assets/AddAxeTemplate.xlsx'
import { SplitButtonDropdown, ActionItem, SplitButtonType } from 'view/components/menus'
import { ModalConsumerProps, withModal } from 'view/shared/modal'
import { AxeAdd } from './AxeAddModal'
import { AxeUploadDialog } from 'view/shared/axeUpload/AxeUploadDialog'

interface AxeBoardToolbarProps extends ModalConsumerProps {
  canManage: boolean
}

const SplitButtonStyled = styled(SplitButtonDropdown)`
  max-width: 120px;
`

const AxeBoardToolbarComponent: React.FC<AxeBoardToolbarProps> = ({ showModal, canManage }) => {
  const actions: ActionItem[] = canManage
    ? [
        {
          label: Locale.translate(Translation.TC_AXE_NEW),
          type: SplitButtonType.Primary,
          onClick: () => showModal(<AxeAdd />),
          enabled: true
        },
        {
          label: Locale.translate(Translation.TC_ACTION_UPLOAD_SPREADSHEET),
          type: SplitButtonType.Primary,
          onClick: () => showModal(<AxeUploadDialog />),
          enabled: true
        },
        {
          label: Locale.translate(Translation.TC_ACTION_DOWNLOAD_SPREADSHEET),
          type: SplitButtonType.Primary,
          onClick: () => {
            downloadUrl(axeUploadTemplateUrl, Locale.translate(Translation.TC_DOWNLOAD_AXE_TEMPLATE_FILENAME))
          },
          enabled: true
        }
      ]
    : []

  return <SplitButtonStyled dataTestId="AxeBoard-Toolbar-Action" actions={actions} maxButtons={1} autoHideEllipsis={true} />
}

export const AxeBoardToolbar = withModal(connect(createStructuredSelector({ canManage: canManageAxeSelector }))(AxeBoardToolbarComponent))
